import { render, staticRenderFns } from "./ServerName.vue?vue&type=template&id=825dace4&scoped=true&"
import script from "./ServerName.vue?vue&type=script&lang=ts&"
export * from "./ServerName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825dace4",
  null
  
)

export default component.exports